import { DeviceMobile } from "@phosphor-icons/react";

export const toShortEmbed = (url) => {
  const tk = url.match(/tiktok\.com\/.*video\/(\d+)/);
  if (tk) return { type: "iframe", src: `https://www.tiktok.com/embed/v2/${tk[1]}` };
  const yt = url.match(/youtube\.com\/shorts\/([\w-]+)|youtu\.be\/([\w-]+)|youtube\.com\/watch\?v=([\w-]+)/);
  if (yt) return { type: "iframe", src: `https://www.youtube.com/embed/${yt[1] || yt[2] || yt[3]}` };
  return { type: "file", src: url };
};

const ShortCard = ({ url, i }) => {
  const e = toShortEmbed(url);
  return (
    <div data-testid={`short-video-${i}`} className="snap-center shrink-0 w-[220px] sm:w-[260px] aspect-[9/16] rounded-3xl overflow-hidden bg-black border-4 border-stone-900 shadow-xl">
      {e.type === "iframe" ? (
        <iframe src={e.src} title={`Vidéo courte ${i + 1}`} className="w-full h-full" allow="autoplay; encrypted-media; picture-in-picture" allowFullScreen />
      ) : (
        <video src={e.src} className="w-full h-full object-cover" controls loop muted playsInline autoPlay />
      )}
    </div>
  );
};

export const ShortVideos = ({ videos }) => {
  if (!videos?.length) return null;
  return (
    <div data-testid="short-videos-section">
      <h2 className="font-display text-xl font-bold text-stone-900 mt-8 flex items-center gap-2">
        <DeviceMobile weight="fill" className="text-orange-800" /> Vidéos courtes du bien
      </h2>
      <div className="flex gap-4 overflow-x-auto snap-x snap-mandatory pb-3 mt-3">
        {videos.map((v, i) => <ShortCard key={i} url={v} i={i} />)}
      </div>
    </div>
  );
};
